import { Pin } from '@vis.gl/react-google-maps'

export const LudaPhamarcyPin = (): JSX.Element => (
  <Pin
    background='#2aa73c'
    borderColor='#1e742a'
    glyphColor='#14571e'
  />
)
